import Vue from 'vue'
import VueRouter from 'vue-router'
import Project from '../views/Project.vue'
// import Microreact from '../views/Microreact.vue'
import Nextstrain from '../views/Nextstrain.vue'
// import Nextstrain from '../views/Nextstrain2.vue'

// import SSI from '../views/SSI.vue'
import AboutUs from '../views/AboutUs.vue'
import Contact from '../views/Contact.vue'
// import Auth from '../views/Auth.vue'
import Statistics from '../views/Statistics.vue'

import NotFound from '../views/NotFound.vue'
import IE from '../views/IE.vue'

// import store from '../store/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'None',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'Project',
		component: Project,
		meta: {
			requiresAuth: true
		}
  },
  // {
  //   path: '/microreact',
  //   name: 'Microreact',
	// 	component: Microreact,
	// 	meta: {
	// 		requiresAuth: true
	// 	}
	// },
	{
    path: '/nextstrain',
    name: 'Nextstrain',
		component: Nextstrain,
		meta: {
			requiresAuth: true
		}
  },
  // {
  //   path: '/statistics',
  //   name: 'SSI',
	// 	component: SSI,
	// 	meta: {
	// 		requiresAuth: true
	// 	}
	// },
	{
		path: '/statistics',
		name:'Statistics',
		component: Statistics,
		meta:{
			requiresAuth: true
		}
	},
	{
    path: '/about',
    name: 'AboutUs',
		component: AboutUs,
		meta: {
			requiresAuth: true
		}
  },
  {
    path: '/contact',
    name: 'Contact',
		component: Contact,
		meta: {
			requiresAuth: true
		}
	},
	// {
  //   path: '/auth',
  //   name: 'Authentication',
  //   component: Auth
	// },
	{
		path: '/IE-not-supported',
		name:'IE',
		component: IE
	},
  {
    path:'*',
    name:'Page Not Found',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
	if (router.app.$browserDetect.isIE) {
		next('/EI-not-supported')
	}
	next()

  // if (to.meta.requiresAuth) {
  //   if (store.getters.is_logged_in === false){
	// 		next('/auth')
	// 	}
  //   else next()
  // } else next()
})

export default router
